import { Spin } from 'antd'
import CantileverButton from 'components/CantileverButton'
import { PdfViewer } from 'features/files'
import React from 'react'
import styled from 'styled-components'
import { StyledCloseIcon } from 'styles/assetDatabaseStyles'

interface PdfPreviewerProps {
  pdfURL: string | null
  setIsPdfPreviewOpen: React.Dispatch<React.SetStateAction<boolean>>
  isLoading: boolean
  fileType: string
}

const PDFPreviewContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

const ViewerWrapper = styled.div`
  width: 90%;
  height: 95%;
`

const CenteredSpin = styled(Spin)`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const CloseModalContainer = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  cursor: pointer;
`

const NoPreviewMessage = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.forecast.activeText};
  font-size: 1.5rem;
  line-height: 1.25rem;
  font-weight: medium;
`

const PDFPreviewer: React.FC<PdfPreviewerProps> = ({
  pdfURL,
  setIsPdfPreviewOpen,
  isLoading,
  fileType,
}) => {
  const handleClosePreview = () => {
    setIsPdfPreviewOpen(false)
  }

  const handleContainerClick = () => {
    handleClosePreview()
  }

  const handleIframeClick = (event: React.MouseEvent<HTMLIFrameElement>) => {
    event.stopPropagation()
  }

  return (
    <PDFPreviewContainer onClick={handleContainerClick}>
      <CloseModalContainer>
        <CantileverButton iconOnly onClick={handleClosePreview}>
          <StyledCloseIcon />
        </CantileverButton>
      </CloseModalContainer>
      {isLoading ? (
        <CenteredSpin />
      ) : pdfURL && fileType.toLowerCase() === 'pdf' ? (
        <ViewerWrapper onClick={handleIframeClick}>
          <PdfViewer url={pdfURL} width={'100%'} height={'100%'} />
        </ViewerWrapper>
      ) : (
        <NoPreviewMessage>No Preview Available</NoPreviewMessage>
      )}
    </PDFPreviewContainer>
  )
}

export default PDFPreviewer
